/* 公共开关：隐藏 Shopify Inbox 的 Support 按钮（<shopify-chat>）。
   多个弹层各自占用一个 key，全部释放后才重新显示。
   window.PqSupportVisibility.hide('cart-drawer')
   window.PqSupportVisibility.show('cart-drawer') */
(() => {
  const SELECTOR = '#shopify-chat, shopify-chat, #ShopifyChat, inbox-online-store-chat';
  const holders = new Set();

  const apply = () => {
    const hidden = holders.size > 0;
    document.documentElement.classList.toggle('pq-support-hidden', hidden);
    document.querySelectorAll(SELECTOR).forEach((element) => {
      element.classList.toggle('hidden', hidden);
    });
  };

  const hide = (key = 'default') => {
    holders.add(String(key));
    apply();
  };

  const show = (key = 'default') => {
    holders.delete(String(key));
    apply();
  };

  window.PqSupportVisibility = { hide, show };
})();
